/* RESPONSIBLE TEAM: team-ai-insights */

import TaskSuggestions from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/task-suggestions';

export default class FinStandaloneTaskSuggestions extends TaskSuggestions {
  analytics = {
    section: 'standalone',
    place: 'task-suggestions',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/task-suggestions';
}
